import { render, staticRenderFns } from "./RecentlyNotice.vue?vue&type=template&id=f0ae57a8&"
import script from "./RecentlyNotice.vue?vue&type=script&lang=js&"
export * from "./RecentlyNotice.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyNotice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_dev\\workspace_front\\aikl_v2_front_kcc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0ae57a8')) {
      api.createRecord('f0ae57a8', component.options)
    } else {
      api.reload('f0ae57a8', component.options)
    }
    module.hot.accept("./RecentlyNotice.vue?vue&type=template&id=f0ae57a8&", function () {
      api.rerender('f0ae57a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/RecentlyNotice.vue"
export default component.exports